import styled from 'styled-components';

interface ITooltipProps {
  absolutePos?: boolean;
}

export const STooltipError = styled.div<ITooltipProps>`
  color: ${({ theme }) => theme.colors.error};
  position: ${({ absolutePos }) => (absolutePos ? 'absolute' : 'unset')};
  bottom: 1px;
  left: 5px;
  margin-left: ${({ absolutePos }) => (absolutePos ? 'unset' : '10px')};
`;
